import AzImg from '~/components/Atoms/AzImg.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';


export default {
  __name: 'AppReinsurance',
  props: {
  reinsuranceItems: {
    type: Array,
    required: true,
    default: () => [],
  },
},
  setup(__props) {

const props = __props;



/**
 * Returns the item's link
 *
 * @param      {Object}  item    The item
 * @return     {String}  The link
 */
function getItemLink(item) {
  return item.externalLinkUrl ?? '';
}

return { __sfc: true,props, getItemLink, AzImg, NuxtLinkCustom }
}

}